/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Pipe, PipeTransform} from '@angular/core';
import appUtil from '../util/app.util';

@Pipe({
  name: 'filter',
  standalone: true,
})
export class FilterPipe implements PipeTransform {
  transform(items: any, searchText: string): any {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter((it: any) => {
      console.log(
        Object.values(it).map((i) => i?.toString()?.toLocaleLowerCase()),
        searchText
      );
      // return it?.CustomerName.toLocaleLowerCase().indexOf(searchText) !== -1;
      return Object.values(it)
        .map((i) => i?.toString()?.toLocaleLowerCase())
        .some((i) => i?.includes(searchText));
    });
  }
}
